import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const ASSET = (path) => !path ? "" : (path.startsWith("/") ? `${BACKEND_URL}${path}` : path);

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ti_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Fire-and-forget tracking — never throw, never block UI
export const track = (product_type, product_id, kind) => {
  if (!product_type || !product_id || !kind) return;
  api.post("/track", { product_type, product_id, kind }).catch(() => {});
};

export default api;
